let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1UoOL")).then(() => parcelRequire('3iYvl'));